import { FC } from 'react';
import { Section } from './ui/Section';

export const Summary: FC<{ summary: string; title?: string }> = ({
  summary,
  title = 'Summary',
}) => (
  <Section title={title}>
    <p>{summary}</p>
  </Section>
);

export default Summary;
